var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import League from './League';
import { leagueSortFunc } from "../../../rendering-commons/Sorting";
var Sport = /** @class */ (function (_super) {
    __extends(Sport, _super);
    function Sport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Sport.prototype.componentDidMount = function () {
        if (localStorage.getItem('lastExpandedLeague') && document.getElementById("league-".concat(+localStorage.getItem('lastExpandedLeague')))) {
            var root = document.getElementById('root');
            root.scrollTop = document.getElementById("league-".concat(+localStorage.getItem('lastExpandedLeague'))).offsetTop - 48;
            localStorage.removeItem('lastExpandedLeague');
        }
    };
    Sport.prototype.render = function () {
        var _a = this.props, sport = _a.sport, section = _a.section, expandedLeague = _a.expandedLeague, gridLocalization = _a.gridLocalization, filterType = _a.filterType;
        var leagues = this.props.leagues.filter(function (league) { return sport.get('leagues').includes(league.get('id')); });
        var renderLeagues = [];
        var props = {
            expandedLeague: expandedLeague,
            gridLocalization: gridLocalization,
            section: section,
            filterType: filterType
        };
        leagues.sort(leagueSortFunc).forEach(function (league) {
            renderLeagues.push(_createElement(League, __assign({ id: league.get('id') }, props, { key: league.get('id') })));
        });
        return (_jsx("div", __assign({ className: 'section' }, { children: renderLeagues })));
    };
    return Sport;
}(React.Component));
Sport.propTypes = {
    gridLocalization: PropTypes.object.isRequired,
    expandedLeague: PropTypes.any,
    section: PropTypes.string.isRequired,
    sport: PropTypes.object.isRequired,
    leagues: PropTypes.object.isRequired
};
var mapStateToProps = function (state, props) { return ({
    leagues: state.application.getIn([props.section, 'leagues'])
}); };
export default connect(mapStateToProps)(Sport);



// WEBPACK FOOTER //
// ./src/components/grid/sports/Sport.jsx